const ArticleContents = () => {
  const contentsItems = [...document.querySelectorAll(".article-main__contents ul li")];
  const textLinks = [...document.querySelectorAll('.article-main__contents .text-link')];
  const headings = [...document.querySelectorAll('.vc_custom_heading')];

  if (contentsItems.length > 0) {
    // Изначально добавляем класс active на первый элемент
    contentsItems[0].classList.add("active");

    // Добавляем событие на клик для каждого пункта оглавления
    contentsItems.forEach((item) => {
      item.addEventListener("click", () => {
        contentsItems.forEach((i) => i.classList.remove("active"));
        item.classList.add("active");
      });
    });
  }

  // Форматируем текст ссылок, убираем цифры в начале
  if (textLinks.length > 0) {
    textLinks.forEach((textLink) => {
      let text = textLink.textContent.trim();
      text = text.replace(/^\d+\.?\s*/, '');
      textLink.textContent = text;
    });
  }

  // Логика для активации ссылки при попадании заголовков в область видимости
  if (headings.length > 0) {
    let visibleHeadings = [];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const index = visibleHeadings.indexOf(entry.target);

        if (entry.isIntersecting) {
          if (index === -1) {
            visibleHeadings.push(entry.target);
          }
        } else {
          if (index > -1) {
            visibleHeadings.splice(index, 1);
          }
        }
      });

      // Определяем самый верхний видимый заголовок
      if (visibleHeadings.length > 0) {
        const topHeading = visibleHeadings[0];
        const activeId = topHeading.id;

        // Убираем класс active со всех пунктов оглавления
        contentsItems.forEach((item) => item.classList.remove('active'));

        // Находим пункт оглавления, соответствующий самому верхнему заголовку
        const activeItem = document.querySelector(`.article-main__contents a[href="#${activeId}"]`)?.parentElement;
        if (activeItem) {
          activeItem.classList.add('active');
        }
      }
    }, { threshold: 0 });

    // Наблюдаем за всеми заголовками
    headings.forEach((heading) => observer.observe(heading));
  }
};

export default ArticleContents;

// Код без observer
// const ArticleContents = () => {
//   const contentsItems = [...document.querySelectorAll(".article-main__contents ul li")];
//   const textLinks = [...document.querySelectorAll('.article-main__contents .text-link')];

//   if (contentsItems.length > 0) {
//     contentsItems[0].classList.add("active");

//     contentsItems.forEach((item) => {
//       item.addEventListener("click", () => {
//         contentsItems.forEach((i) => {
//           i.classList.remove("active");
//         });
        
//         item.classList.add("active");
//       });
//     })
//   }
  
//   if (textLinks.length > 0) {
//     textLinks.forEach((textLink) => {
//         let text = textLink.textContent.trim();
//         text = text.replace(/^\d+\.?\s*/, '');
//         textLink.textContent = text;
//     });
//   }
// }

// export default ArticleContents